import { PATH_AUTH } from 'routes/paths'
import config from 'config';

export const getLoginWithReturnUrl = ()  => {
    const url = new URL(window.location);
    const basename = config.basename || ''; // Získání hodnoty basename z konfigurace
    let pathname = url.pathname;

    // Odstranění basename z URL, pokud je na začátku
    if (pathname.startsWith(basename)) {
        pathname = pathname.substring(basename.length) || '/';
    }

    const redirectTo = PATH_AUTH.login +
        ((url.pathname === '/')
            ? ''
            : '?url=' + encodeURIComponent(pathname + url.search));
    return redirectTo;
}
